import { atom, useAtom, useSetAtom } from "jotai";

export type priorityModals =
  | ""
  | "pendingPayment"
  | "kioskIdle"
  | "orderCancelledByExternalProvider"
  | "cashDroPayment"
  | "cashDroCancelRefund"
  | "confirmation";

interface Modal {
  meta: any;
  priorityModal: priorityModals;
}
export const modalAtom = atom<Modal>({
  meta: {},
  priorityModal: "",
});

export const modalMetaAtom = atom((get) => get(modalAtom).meta);

export const usePriorityModalMeta = () => {
  const atom = useAtom(modalMetaAtom);
  return atom;
};

const usePriorityModal = () => {
  const atom = useAtom(modalAtom);
  return atom;
};

export const useSetPriorityModal = () => {
  const set = useSetAtom(modalAtom);
  return (modal: priorityModals, meta = {}) =>
    set({
      priorityModal: modal,
      meta,
    });
};

export default usePriorityModal;
